<template>
  <div
    class="dui-video-player"
    :class="{ 'empty': !url,
              'invalid': (url && vm.isInvalidVideo) }"
  >
    <span
      v-if="!url"
      class="no-video-text"
    >
      {{ emptyText }}
    </span>

    <span
      v-if="(url && vm.isInvalidVideo)"
      class="invalid-video-text"
    >
      Invalid video
    </span>

    <DuiYoutubeVideo
      v-if="(url && source === 'youtube')"
      v-show="!vm.isInvalidVideo"
      :url="url"
      @invalid-video="invalidVideoReceived"
      @valid-video="validVideoReceived"
    />
  </div>
</template>

<script>
import DuiYoutubeVideo from './dui-youtube-video/dui-youtube-video.vue';

export default {
  components: {
    DuiYoutubeVideo,
  },
  props: {
    emptyText: {
      type: String,
      default: 'No video',
    },
    source: {
      type: String,
      required: true,
      validator: function (value) {
        return [ 'youtube' ].indexOf(value) !== -1;
      },
    },
    url: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    vm: {
      isInvalidVideo: false,
    },
  }),
  methods: {
    invalidVideoReceived() {
      this.$set(this.vm, 'isInvalidVideo', true);
    },
    validVideoReceived() {
      this.$set(this.vm, 'isInvalidVideo', false);
    },
  },
};
</script>

<style lang="scss">
@import "@dui-styles/base";

.dui-video-player {
  background-color: getColor($grey);
  border-radius: $border-radius-base;
  display: flex;
  height: 0;
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;

  @include transition((
    background-color,
    box-shadow
  ));

  &.empty {
    box-shadow: inset 0 0 $_2em 0 getColor($grey, fade);
  }

  &.invalid {
    background-color: getColor($red, faint);
    box-shadow: inset 0 0 $_2em 0 getColor($red, fade);
  }

  .invalid-video-text,
  .no-video-text {
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
    z-index: 1;
  }

  .invalid-video-text {
    color: getColor($red, dark);
  }

  .no-video-text {
    color: getColor($grey, dark);
  }

  .dui-video {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
}
</style>
